import {bookingConfig, DeliveryType} from "../types/types";
import {isWithinInterval, parseISO} from 'date-fns'

export class DeliveryManager {
    private config: bookingConfig;


    constructor(config: bookingConfig) {
        this.config = config;
    }

    public isProbablyFreeDelivery(quantity: number) {
        let probablyFree = Object.keys(this.config.FreeDeliveryPagesList).some(key => document.location.href.includes(key));

        if (probablyFree) {
            return true;
        }

        return this.config.possibleFreeDeliveryLabel && quantity >= this.config.IMinimumAmountGunsForAFreeDeliveryInCertainRegions;
    }

    public isFreePhoenixDelivery(quantity: number) {
        return quantity >= this.config.IFreeDeliveryFromNumberOfLaserGuns;
    }

    public isFreeZIPBasedOnUrl(zip: string) {
        for (const [key, zips] of Object.entries(this.config.FreeDeliveryPagesList)) {
            if (document.location.href.includes(key)) {
                return zips.includes(zip);
            }
        }

        return false;
    }

    public isFreeZip(zip: string) {
        return this.config.freeZips.includes(zip);
    }

    public isAmountEnoughForDeliveryInRegion(quantity: number) {
        return quantity >= this.config.IMinimumAmountGunsForAFreeDeliveryInCertainRegions;
    }

    public isFreeDeliveryDate(date: Date) {
        return this.checkDateInIntervals(date, this.config.freeDeliveryInterval)
            || this.checkDateInIntervals(date, this.config.promoIntervals);
    }

    checkDateInIntervals(date: Date, intervals: any) {
        return intervals.some((interval: any) => {
            return isWithinInterval(date, {start: parseISO(interval.start), end: parseISO(interval.end)})
        });
    }

    public isDiscount50DeliveryDate(date: Date) {
        return this.checkDateInIntervals(date, this.config.discount50DeliveryInterval);
    }

    public allowedToRentInExternalRentalPoints(quantity: number) {
        return quantity <= this.config.INumberOfLaserGunsNotAllowedToReserveInRentalPoints;
    }

    public isDPDPointDelivery(delivery: string) {
        return DeliveryType.ProbablyFree === delivery
            || DeliveryType.Free === delivery
            || DeliveryType.DPDPoint === delivery
            || DeliveryType.DPDPoint50Discount === delivery;
    }

    public isTransforceDelivery(delivery: string) {
        return [
            DeliveryType.DPD,
            DeliveryType.DPDFree,
            DeliveryType.DPD50Discount,
            DeliveryType.Transforce,
            DeliveryType.TransforceBow,
            DeliveryType.TransforceFree,
            DeliveryType.Transforce50Discount,
            //string value below is used to prevent TS compiler show type mismatch error
            'some value'
        ].indexOf(delivery) !== -1;
    }

    public eligibleYouthMovementSummerPromo(date: Date) {
        return this.config.youthMovementPromotionInterval.some(interval => {
            return isWithinInterval(date, {start: parseISO(interval.start), end: parseISO(interval.end)})
        });
    }

}
